import { render, staticRenderFns } from "./ProfanityFilterBlacklist.vue?vue&type=template&id=3de1bda9&"
import script from "./ProfanityFilterBlacklist.vue?vue&type=script&lang=js&"
export * from "./ProfanityFilterBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports